import { Record } from 'immutable';

import prefix from 'OPENTOK/prefix';

export const SESSION_STATUS_INIT = prefix('SESSION_STATUS_INIT');
export const SESSION_STATUS_CONNECTED = prefix('SESSION_STATUS_CONNECTED');
export const SESSION_STATUS_RECONNECTING = prefix('SESSION_STATUS_RECONNECTING');
export const SESSION_STATUS_DISCONNECTED = prefix('SESSION_STATUS_DISCONNECTED');

const SessionRecord = Record({
  id: null,
  object: null,
  status: SESSION_STATUS_INIT,
});

export default class Session extends SessionRecord {
  isEnablePublish() {
    return this.object && this.status === SESSION_STATUS_CONNECTED;
  }
}
